import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from './SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiAlertCircle, FiX } = FiIcons;

const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColors = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800',
  };

  const iconColors = {
    success: 'text-green-500',
    error: 'text-red-500',
    info: 'text-blue-500',
  };

  const Icons = {
    success: FiCheckCircle,
    error: FiAlertCircle,
    info: FiAlertCircle,
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 20, scale: 0.9 }}
      className={`fixed bottom-6 right-6 z-50 flex items-center p-4 rounded-lg shadow-lg border ${bgColors[type]} min-w-[300px] max-w-md`}
    >
      <SafeIcon icon={Icons[type]} className={`text-xl mr-3 ${iconColors[type]}`} />
      <p className="flex-1 text-sm font-medium">{message}</p>
      <button onClick={onClose} className="ml-4 text-gray-400 hover:text-gray-600">
        <SafeIcon icon={FiX} />
      </button>
    </motion.div>
  );
};

export default Toast;